// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"selectBoundsMap_wrapper__3ZGLA","map-wrapper":"selectBoundsMap_map-wrapper__1aiR4","leaflet-container":"selectBoundsMap_leaflet-container__15ZfM"};